import { createFileRoute } from '@tanstack/react-router'
import { Cashflow } from '../screens/Cashflow'
import { useAppState } from '../app-state'
import { RoleGuard } from '../components/RoleGuard'

function CashflowRoute() {
  const { railSelected } = useAppState()
  return (
    <RoleGuard>
      <Cashflow railSelected={railSelected} />
    </RoleGuard>
  )
}

export const Route = createFileRoute('/cashflow')({
  component: CashflowRoute,
})
